module.exports = __webpack_public_path__ + "img/visibile.b27ed00a.svg";